// extracted by mini-css-extract-plugin
export default {"dialog":"DefaultModal_dialog__7i-15","onClose":"DefaultModal_onClose__jQfSa"};